export const poeticDevicesPool = [
    {
      line: "She sells seashells by the seashore.",
      device: "Alliteration",
      distractors: ["Metaphor", "Simile", "Personification"]
    },
    {
      line: "Life is a journey.",
      device: "Metaphor",
      distractors: ["Simile", "Onomatopoeia", "Alliteration"]
    },
    {
      line: "The rain danced on the rooftop.",
      device: "Personification",
      distractors: ["Metaphor", "Hyperbole", "Alliteration"]
    }
  ];
  
  export const identifyPoeticDevicesPool = [
    {
      stanza: "Bright blue butterflies flutter by,\nBringing beauty to the sky.",
      devices: ["Alliteration", "Imagery"]
    },
    {
      stanza: "The thunder roared as the rain poured.",
      devices: ["Onomatopoeia", "Rhyme"]
    }
  ];
  